import { BaseComponent } from 'src/app/shared/components/base.component';
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { type } from 'os';
import { AuthenticationService } from '../http/authentication.service';

@Injectable({ providedIn: 'root' })

export class AlertSummaryService extends BaseComponent {
    private message = new BehaviorSubject<string[]>(null);
    private type = new BehaviorSubject<string>('');
    // private keepAfterNavigationChange = false;

    public message$ = this.message.asObservable();
    public type$ = this.type.asObservable();

    constructor(
        private router: Router,
        protected authenticationService: AuthenticationService,
        ) {
        super(authenticationService);
        // clear alert message on route change
        router.events
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(event => {
            if (event instanceof NavigationStart) {
                // clear alert summury messages
                this.message.next(null);
                // console.log(event);
                // if (this.keepAfterNavigationChange) {
                //     // only keep for a single location change
                //     this.keepAfterNavigationChange = false;
                // } else {
                //     // clear alert
                //     this.message.next(null);
                // }
            }
        });
    }


    success(message: string[] | string) {
        this.show('success', message);
    }

    info(message: string[] | string) {
        this.show('info', message);
    }

    warning(message: string[] | string) {
        this.show('warning', message);
    }

    error(message: string[] | string) {
        this.show('error', message);
    }

    show(msgType: string, message: string[] | string) {
        this.type.next(msgType);
        if (typeof(message) === 'string') {
            this.message.next([message]);
        } else {
            this.message.next(message);
        }
    }

    clear() {
        this.type.next('');
        this.message.next(null);
    }

    // getMessage(): Observable<any> {
    //     return this.message.asObservable();
    // }
}




@Injectable({ providedIn: 'root' })

export class NestedAlertSummaryService extends AlertSummaryService {

    constructor(
        private nestedRouter: Router,
        protected authenticationService: AuthenticationService,
        ) {
        super(nestedRouter, authenticationService);
    }
}


@Injectable({ providedIn: 'root' })

export class DoubleNestedAlertSummaryService extends AlertSummaryService {

    constructor(
        private doubleNestedRouter: Router,
        protected authenticationService: AuthenticationService,
        ) {
        super(doubleNestedRouter, authenticationService);
    }
}

